export default {
  header: 'Menü Wählen',
};
